import styled from 'styled-components';
import DepositIconDark from '../../assets/images/deposit-icon.svg';
import DepositIconLight from '../../assets/images/deposit-icon-light.svg';

const DepositIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${DepositIconDark}") no-repeat left center`
      : `url("${DepositIconLight}") no-repeat left center`};
  background-size: 23px 23px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  height: 23px;
  width: 23px;
`;

export default DepositIcon;
